var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.667.667h22.667v22.667H.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M2.833 4.895h-.17c-1.101 0-1.726.848-1.394 1.897l1.9 6.001c.165.523.742.947 1.306.947h5.433"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M16.188 4.895h.17c1.101 0 1.726.848 1.393 1.897l-1.9 6.001c-.165.523-.741.947-1.305.947H9.113M5.982 7.456v3.73M13.019 7.456v3.73M9.5 7.456v3.73M11.365 5.099h-3.73"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.926,
    cy: 4.926,
    r: 1.407,
    fill: "#80959D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.074,
    cy: 4.926,
    r: 1.407,
    fill: "#80959D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M7.944.446L4.997 4.73M11.33.446l2.947 4.284"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.35e798f9f4adaa193dabdc508aa1cfb8.svg";
export { ForwardRef as ReactComponent };